<template>
  <com-solt title="重置密码" :isShopView="isShopView" :GetShopInfoNoLogin="GetShopInfoNoLogin">
    <div class="main">
      <div class="container1 content">
        <div class="first_row">
          <span>验证身份</span>
          <span class="line"></span>
          <span class="wait">找回密码</span>
          <span class="line"></span>
          <span class="wait">完成</span>
        </div>
        <div class="second_row">为确认是你本人操作，请选择验证方式完成身份验证：</div>
        <div class="last_row com_between">
          <span>通过手机验证</span>
          <el-button type="primary btn_yel w178 bor_rad0" @click="dialogVisible=true">手机验证</el-button>
        </div>
      </div>

      <el-dialog class="edit_pwd" title="重置密码" :visible.sync="dialogVisible" :close-on-press-escape="false" :close-on-click-modal="false" width="1280px" @close="closeDialog">
        <div class="edit_box">
          <el-form ref="form" :model="dataForm" :rules="rules" label-width="0px" label-position="left">
            <el-form-item prop="mobile">
              <el-input v-model="dataForm.mobile" placeholder="请输入手机号码"></el-input>
            </el-form-item>

            <el-form-item class="phone_code" prop="verCode">
              <el-input v-model="dataForm.verCode" placeholder="手机验证码"></el-input>
              <el-button @click="sendVerCode" :disabled="downTime>0" class="btn">{{downTime>0?downTime+'秒后重发':'发送验证码'}}</el-button>
            </el-form-item>

            <el-form-item prop="password">
              <el-input show-password v-model="dataForm.password" auto-complete="new-password" placeholder="请输入密码"></el-input>
            </el-form-item>

            <el-form-item prop="password_conf">
              <el-input show-password v-model="dataForm.password_conf" placeholder="请确认密码"></el-input>
            </el-form-item>

            <el-form-item prop="valueSlider">
              <drag-verify ref="dragVerify" class="verify" :isPassing.sync="dataForm.valueSlider" :width="306" :height="30" textSize="12px" radius="0px" text="请按住滑块，拖动到最右边" success-text="验证通过" handlerIcon="fa el-icon-d-arrow-right" successIcon="fa el-icon-circle-check"></drag-verify>
            </el-form-item>

            <el-form-item class="submit">
              <el-button type="primary btn_yel bor_rad0" @click="submitEditPwd">提交</el-button>
            </el-form-item>
          </el-form>
        </div>
      </el-dialog>
    </div>
  </com-solt>
</template>

<script>
import ComSolt from "./components/comSolt";
import dragVerify from "vue-drag-verify2";
import {
  validMobile,
  checkSlider,
  checkVerCode,
  validatePwd,
} from "@/pages/publicUtils/validate";
export default {
  metaInfo: { title: "账户服务中心" },
  name: "retrievePwd",
  components: { ComSolt, dragVerify },
  props: {
    SaveFindPass: {
      type: Function,
      default: () => {},
    },
    FindPassSendVerCode: {
      type: Function,
      default: () => {},
    },
    GetShopInfoNoLogin: {
      type: Function,
      default: () => {},
    },
    isShopView: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    let checkMobile = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("必填"));
      }
      if (!validMobile(value)) {
        return callback(new Error("格式不对"));
      }
      callback();
    };
    let checkPass = (rule, value, callback) => {
      // console.log("密码", validatePwd(value));
      if (!value) {
        return callback(new Error("必填"));
      }
      if (!validatePwd(value)) {
        return callback(new Error("字母和数字组合（8-20位）"));
      }
      if (this.dataForm.password_conf) {
        this.$refs.form.validateField("password_conf");
      }
      callback();
    };
    let checkConf = (rule, value, callback) => {
      // console.log("确认密码", validatePwd(value));
      if (!value) {
        return callback(new Error("必填"));
      }
      if (!validatePwd(value)) {
        return callback(new Error("字母和数字组合（8-20位）"));
      }
      if (value != this.dataForm.password) {
        return callback(new Error("两次输入密码不一致!"));
      }
      callback();
    };
    return {
      dialogVisible: false,
      dataForm: {
        mobile: undefined,
        verCode: undefined,
        password: undefined,
        password_conf: undefined,
        valueSlider: false,
      },
      rules: {
        mobile: [{ validator: checkMobile, trigger: "blur" }],
        valueSlider: [{ validator: checkSlider, trigger: "change" }],
        verCode: [{ validator: checkVerCode, trigger: "blur" }],
        password: [{ validator: checkPass, trigger: "blur" }],
        password_conf: [{ validator: checkConf, trigger: "blur" }],
      },
      downTime: 0,
    };
  },
  methods: {
    submitEditPwd() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.SaveFindPass(this.dataForm).then((res) => {
            // console.log("提交保存密码找回请求", res);
            let _that = this;
            this.$message.success({
              message: "操作成功",
              duration: 1000,
              onClose: () => {
                let newUrl = _that.$router.resolve("/login");
                window.open(newUrl.href, "_self");
              },
            });
          });
        } else {
          return false;
        }
      });
    },
    closeDialog() {
      //   console.log('关闭dialog');
      this.$refs.form.resetFields();
      this.$refs.dragVerify.reset();
    },
    sendVerCode() {
      this.$refs.form.validateField("mobile", (err) => {
        if (!err) {
          this.FindPassSendVerCode({ mobile: this.dataForm.mobile }).then(
            (res) => {
              // console.log("获取到的验证码", res);
              this.dataForm.verCode = res.data[0].verCode;
              this.downTime = 60;
              let aTime = setInterval(() => {
                this.downTime -= 1;
                // console.log(this.downTime);
                if (this.downTime <= 0) {
                  clearInterval(aTime);
                }
              }, 1000);
            }
          );
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.main {
  height: 598px;
  border: 1px solid @themeColor;
  border-left: none;
  border-right: none;
  .content {
    padding-top: 120px;
    margin: 0 auto;
    width: 960px;
    font-size: 18px;
    font-weight: 500;
    color: rgba(26, 26, 26, 1);
    .first_row {
      display: flex;
      align-items: center;
      margin-bottom: 56px;
      .wait {
        color: rgba(144, 144, 144, 1);
      }
      .line {
        width: 300px;
        height: 1px;
        box-sizing: border-box;
        margin: 0 28px;
        background: rgba(144, 144, 144, 1);
      }
    }
    .second_row {
      margin-bottom: 48px;
    }
    .last_row {
      margin-bottom: 38px;
      .w178 {
        width: 178px;
      }
    }
  }
}
.edit_pwd {
  /deep/ .el-dialog {
    padding: 0 40px;
    .el-dialog__header {
      padding-bottom: 26px;
      text-align: center;
      border-bottom: 1px solid rgba(170, 170, 170, 1);
      .el-dialog__title {
        padding-bottom: 20px;
        font-size: 28px;
        font-weight: 800;
        color: rgba(26, 26, 26, 1);
        border-bottom: 3px solid rgba(255, 158, 0, 1);
      }
    }
    .el-dialog__body {
      padding: 0;
      padding-bottom: 170px;
      .edit_box {
        width: 306px;
        padding-top: 56px;
        margin: 0 auto;
      }
    }
  }
}
/deep/ .el-form {
  .el-form-item {
    height: 30px;
    margin-bottom: 20px;
    .el-form-item__content {
      line-height: 0px;
      height: 100%;
      .el-input {
        height: 100%;
        .el-input__inner {
          height: 100%;
          line-height: 30px;
          font-size: 14px;
        }
        .el-input__icon {
          line-height: 0px;
        }
      }
      .el-form-item__error {
        left: 120%;
        width: 180px;
        height: 30px;
        padding: 0;
        box-sizing: border-box;
        line-height: 30px;
        text-align: center;
        border: 1px dashed rgba(255, 170, 32, 1);
        top: 0px;
        font-weight: 400;
        color: rgba(255, 158, 0, 1);
        &::after {
          content: " ";
          display: inline-block;
          height: 10px; /*height、width控制箭头大小*/
          width: 10px;
          border-width: 0px 0px 1px 1px;
          border-color: rgba(255, 158, 0, 1);
          border-style: dashed;
          -webkit-transform: matrix(-0.71, 0.71, 0.71, 0.71, 0, 0);
          /*前面四个参数控制箭头方向 最后两个参数分别控制距离左侧的距离 距离上侧的距离*/
          transform: matrix(0.71, -0.71, -0.71, -0.71, 0, 0);
          position: absolute;
          top: 9px;
          left: -50px;
        }
        &::before {
          content: " ";
          display: inline-block;
          height: 0px; /*height、width控制箭头大小*/
          width: 26px;
          border-bottom: 1px dashed rgba(255, 158, 0, 1);
          position: absolute;
          top: 14px;
          left: -34px;
        }
      }
    }
    .el-form-item__label {
      line-height: 30px;
    }
  }
  .phone_code {
    .el-form-item__content {
      .el-input {
        width: 178px;
      }
      .btn {
        //   position: absolute;
        //   top: 0px;
        //   right: -128px;
        width: 124px;
        height: 30px;
        line-height: 30px;
        padding: 0 26px;
        margin-left: 4px;
        background: rgba(26, 26, 26, 1) !important;
        color: #ffffff;
      }
      .is-disabled {
        color: #c0c4cc;
        border-color: #ebeef5;
      }
    }
  }
  .submit {
    .btn_yel {
      height: 30px;
      line-height: 30px;
      padding: 0 10px;
      width: 100%;
    }
  }
}
</style>